import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = { searchUrl: String }

  connect() {
    this.tomSelect = new TomSelect(this.element, {
      searchField: ['text'],
      placeholder: 'Search by Patient PIN or Name...',
      allowEmptyOption: true,
      dropdownParent: 'body',
      load: (query, callback) => {
        if (query.length < 2) return callback()
        fetch(`${this.searchUrlValue}?q=${encodeURIComponent(query)}`)
          .then(r => r.json())
          .then(data => callback(data))
          .catch(() => callback())
      },
      render: {
        no_results: () => '<div class="no-results px-3 py-2 text-sm text-gray-500">No patients found</div>',
        loading: () => '<div class="px-3 py-2 text-sm text-gray-400">Searching...</div>'
      },
      onChange: () => {
        this.element.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
